"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const constants_1 = require("./constants");
const serializerr_1 = require("serializerr");
/**
 * Fetches a log level override
 * @param url Remote override url
 * @param accountSid Related Twilio account sid
 */
const fetchLogLevelOverride = (url, accountSid) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield axios_1.default.get(`${url}${accountSid}`);
        return response.data.minLogLevel;
    }
    catch (ex) {
        return null;
    }
});
exports.fetchLogLevelOverride = fetchLogLevelOverride;
/**
 * Send event data to a configured url
 * @param twilioHooks hooks url configuration
 * @param type type of event
 * @param data event data
 * @param logError should log error to console
 */
const sendTwilioEventFormData = (twilioHooks, type, data, logError) => __awaiter(void 0, void 0, void 0, function* () {
    if (!twilioHooks || !twilioHooks[type] || twilioHooks[type].length === 0 || !data) {
        if (logError) {
            console.error(`Could not send Twilio event data to configured hooks: ${JSON.stringify(twilioHooks, null, 2)}`);
        }
        return Promise.resolve();
    }
    const logPromises = twilioHooks[type].map(url => {
        try {
            return axios_1.default
                .post(url, data, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            })
                .catch(e => Promise.reject(new Error(e)));
        }
        catch (error) {
            return Promise.reject(error);
        }
    });
    const results = yield Promise.all(logPromises.map(p => p.catch(e => e)));
    if (logError) {
        results.filter(r => r instanceof Error).map(console.warn);
    }
});
exports.sendTwilioEventFormData = sendTwilioEventFormData;
/**
 * Create a unique v4 uuid
 */
const createUuid = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};
exports.createUuid = createUuid;
/**
 * Used to strip out potential circular object references found during serialization
 * @param valueToStringify Value to stringify
 * @param stripPrivateFields Optional param to specify if keys that start with '_' should be removed
 */
const customStringify = (valueToStringify, stripPrivateFields = false) => {
    const cache = new Set();
    return JSON.stringify(valueToStringify, (key, value) => {
        if (stripPrivateFields && key.substr(0, 1) === "_") {
            return;
        }
        if (typeof value === "object" && value !== null) {
            if (cache.has(value)) {
                // Circular reference found
                try {
                    // If this value does not reference a parent it can be deduped
                    return JSON.parse(JSON.stringify(value));
                }
                catch (err) {
                    // discard key if value cannot be deduped
                    return;
                }
            }
            // Store value in our set
            cache.add(value);
        }
        return value;
    });
};
exports.customStringify = customStringify;
/**
 * Checks if the current environment is Node.js
 * @param nodeProcess instance of the node process
 */
const isNodeEnv = (nodeProcess) => typeof nodeProcess === "object" &&
    typeof nodeProcess.versions === "object" &&
    typeof nodeProcess.versions.node !== "undefined";
exports.isNodeEnv = isNodeEnv;
/**
 * Extracts the worker sid in a Twilio Flex environment
 * @param twilioFlexManager Instance of Twilio Flex Manager
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _getWorkerSid = (twilioFlexManager) => {
    try {
        if (twilioFlexManager && twilioFlexManager.store) {
            return twilioFlexManager.store.getState().flex.worker.source.sid;
        }
        return null;
    }
    catch (error) {
        return null;
    }
};
/**
 * Returns the log source based on the current environment
 */
const _getLogSource = () => (isNodeEnv(process) ? constants_1.logSources.CLOUD_FUNCTION : constants_1.logSources.BROWSER_FUNCTION);
/**
 * Initializes logger configuration
 * @param userConfig User provided configuration
 */
const createConfig = (userConfig) => {
    const config = {
        accountSid: userConfig.accountSid,
        correlationToken: userConfig.correlationToken || createUuid(),
        logSinks: Array.isArray(userConfig.logSinks) ? userConfig.logSinks : [],
        excludedFlexActionNames: Array.isArray(userConfig.excludedFlexActionNames)
            ? userConfig.excludedFlexActionNames
            : [],
        minLogLevelOverrideUrl: userConfig.minLogLevelOverrideUrl,
        source: _getLogSource(),
        logErrorsToConsole: userConfig.logErrorsToConsole == null ? true : !!userConfig.logErrorsToConsole,
        twilioFlexManager: userConfig.twilioFlexManager,
        workerSid: _getWorkerSid(userConfig.twilioFlexManager),
        twilioEventHooks: userConfig.twilioEventHooks,
        internalLoggerTrace: !!userConfig.internalLoggerTrace,
    };
    config.logSinks.forEach(sink => {
        sink.logLevel = sink.logLevel || constants_1.logLevels.INFO;
        sink.piiSafe = !!sink.piiSafe;
    });
    return config;
};
exports.createConfig = createConfig;
/**
 * Wrap value in PII tags
 * @param s string to wrap in PII tags
 */
const tagPII = (s) => `${constants_1.piiTags.START}${s}${constants_1.piiTags.END}`;
exports.tagPII = tagPII;
/**
 * Convert error object to plain object.
 * @param error error to be converted to plain object.
 */
const errorToObject = (error) => serializerr_1.serializerr(error);
exports.errorToObject = errorToObject;
//# sourceMappingURL=utils.js.map